export default __webpack_public_path__ + "images/B7.99371ca.png";